module.exports = __webpack_public_path__ + "static/img/sustainable-strategy_02_2025.a86bc9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-strategy_02_2025.jpg
// module id = Z15I
// module chunks = 100